import React from 'react';
import Link from 'next/link';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faChevronLeft} from '@fortawesome/free-solid-svg-icons';

const BtTermsNotice = (props) => {
    const {goBack} = props;

    return (
        <Container>
            <Row>
                <Col className="p-3">
                    <p>
                        Datele tale completate in campurile de mai sus vor fi utilizate de Banca Transilvania in vederea contactarii tale pentru prezentarea conditiilor aferente produsului de creditare BT ales de tine. Detalii despre modul in care Banca Transilvania prelucreaza datele cu caracter personal regasesti in <Link
                        href="https://www.bancatransilvania.ro/politica-prelucrare-si-protectie-date-personale/"
                        target="_blank">Politica de confidentialitate BT</Link> . 
                    </p>

                    <p>Apasand butonul “Trimite”, intelegi ca aceasta solicitare nu reprezinta o cerere de credit.</p>

                    <Button variant="outline-secondary" onClick={goBack}>
                        <FontAwesomeIcon icon={faChevronLeft} height="16" width="16" className="me-2"/>
                        Înapoi
                    </Button>
                </Col>
            </Row>
        </Container>
    );
}

export default BtTermsNotice;

